<template>
  <div id="app">
    <meta charset="utf-8" name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0"/>
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'app',
  created() {
  },
  methods: {
  }
}
</script>

<style>
  body{
    margin: 0px;
    background-color: #f4f4f4;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue